// extracted by mini-css-extract-plugin
export var borderRadius = "_gh-4";
export var large = "_gh-3";
export var logoContainer = "_gh-0";
export var nameLogo = "_gh-2";
export var small = "_gh-1";